import { store } from '../store'

export default (to, from, next) => {
  if (store.state.cliente.user) {
    next()
  } else {
    if (to.query.p) {
      store.dispatch("cliente/carregarParametroFiltro", {
        p: to.query.p,
      });
    }
    if (to.query.u && to.query.s) {
      store.dispatch("cliente/loginurl", {
        u: to.query.u,
        s: to.query.s,
      }).then((r) => {
        next(`/${to.params.id}/anuncio`)
      });
    }
    next(`/${to.params.id}/login`)
  }
}
